// This component rotates its children by 180 degrees
import React, { ReactNode, useMemo } from 'react'
import classNames from 'classnames'

interface RotateProps {
    children: ReactNode
    className?: string
    style?: Object
    rotateDeg?: 0 | 90 | 180
}

// Rotates child component
export const Rotate = ({ children, className = '', style = {}, rotateDeg = 180 }: RotateProps) => {
    const cn = useMemo(() => {
        return classNames([
            'icon-container',
            {
                'rotated-90': rotateDeg == 90,
                'rotated-180': rotateDeg == 180,
            },
            className,
        ])
    }, [className, rotateDeg])

    return (
        <div style={style} className={cn}>
            {children}
        </div>
    )
}
